import React from 'react';
import { Modal, Button, Table } from 'react-bootstrap';
import moment from "moment";

const EmailRecordModal = ({ show, handleClose, emailRecords = [] }) => {
    return (
        <Modal show={show} onHide={handleClose} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title>Email Records</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Table striped bordered hover responsive>
                    <thead>
                        <tr>
                            <th>Sent To</th>
                            <th>Subject</th>
                            <th>Updated Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        {emailRecords.length === 0 ? (
                            <tr>
                                <td colSpan="3" className="text-center">No records found</td>
                            </tr>
                        ) : (
                            emailRecords.map((record, idx) => (
                                <tr key={idx}>
                                    <td>{record.sentToEmail}</td>
                                    <td>{record.emailSubject}</td>
                                    <td>{moment(record.updatedDate).format("DD MMM YYYY hh:mm:ss a")}</td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </Table>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default EmailRecordModal;
